import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { CoverCreditCardFeesSelector } from '~/components/agreement-controllers/CoverCreditCardFeesSelector';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { getUICompanyName } from '../EditDraftsTable.utils';
export default function CreditCardProcessingFeesCell(param) {
    let { draft, index, contact, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const draftLabel = getUICompanyName(draft, contact, editTableTexts.anchorSample());
    const userInfo = useStore((state)=>state.userInfo);
    const worksAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.business();
    const isPaidByClient = !draft.coverCreditCardFees();
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: t.cardProcessingFees(),
                    testId: "edit-credit-card-processing-fees-modal",
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(CoverCreditCardFeesSelector, {
                        value: draft.coverCreditCardFees(),
                        onChange: (value)=>setDraft(draft.setCoverCreditCardFees(value)),
                        vendorBusinessName: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name,
                        clientBusinessName: contact === null || contact === void 0 ? void 0 : contact.companyName(),
                        testId: "edit-credit-card-processing-fees-modal"
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-credit-card-processing-fees-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: "credit-card-processing-fees-".concat(index),
            children: isPaidByClient ? "Paid by ".concat(draftLabel || 'the client') : "Paid by ".concat((worksAt === null || worksAt === void 0 ? void 0 : worksAt.name) || 'the service provider')
        })
    });
}
